import { render, staticRenderFns } from "./EditPostalCode.vue?vue&type=template&id=c1a87f84"
import script from "./EditPostalCode.vue?vue&type=script&lang=js"
export * from "./EditPostalCode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports